import { Controller } from "@hotwired/stimulus"

// Tiny dropdown for the locale picker — toggles the menu and closes it on
// outside click / Escape.
export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.boundOutside = this.outsideClick.bind(this)
    this.boundEscape = this.escape.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    const open = !this.menuTarget.classList.contains("hidden")
    if (open) this.close()
    else this.open()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.boundOutside)
    document.addEventListener("keydown", this.boundEscape)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.boundOutside)
    document.removeEventListener("keydown", this.boundEscape)
  }

  outsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  escape(event) {
    if (event.key === "Escape") this.close()
  }
}
